import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Icon, TabsDeprecated, PaneDeprecated } from '@adc/ui-adc'
import MediaPanel, { View as MediaView } from './mediaPanel'
import { Map, Carousel, NotAvailable } from './mediaPanel/views'
import Pin from './pin'
import styles from './index.scss'

const cx = classnames.bind(styles)

/* eslint-disable react/jsx-curly-newline */
const Overlay = ({
  config,
  view,
  onViewChange,
  onClose,
  addressTuple,
  images,
  coords,
  children,
}) => {
  let panes = []
  const hasValidCoords = !!coords.lat && !!coords.lng
  const elmId = 'pdp_photo'

  if (images.length) {
    panes.push(
      <PaneDeprecated
        id='images'
        key='images'
        className={cx('pane')}
        label={
          <span
            className={cx('tab-label')}
            data-elm-id='property_gallery_panel_image'
          >
            <Icon
              name='image'
              iconStyle='light'
              // We need this to use the color from the `tab-icon` class
              style={{ color: 'inherit' }}
              size='large'
              className={cx('tab-icon')}
            />
            <span>Photos</span>
          </span>
        }
      >
        <Carousel
          images={images}
          className={cx('carousel')}
          elmId={elmId}
          cls={{ left: cx('arr-prev'), right: cx('arr-next') }}
          arrowIconProps={{
            elmId,
          }}
        />
      </PaneDeprecated>
    )
  }

  panes = panes.concat([
    <PaneDeprecated
      id='map'
      key='map'
      className={cx('pane')}
      label={
        <span className={cx('tab-label')} id='property_gallery_panel_map'>
          <Icon
            name='map-marked'
            iconStyle='light'
            style={{ color: 'inherit' }}
            size='large'
            className={cx('tab-icon')}
          />
          <span>Map view</span>
        </span>
      }
    >
      {hasValidCoords ? (
        <Map
          {...coords}
          className={cx('map-view')}
          elmId='property_gallery_panel_map_view'
          apiKey={config.GOOGLE_MAP_CLIENT_ID}
          apiChannel={config.GOOGLE_MAP_CHANNEL}
        >
          <Pin {...coords} />
        </Map>
      ) : (
        <NotAvailable text='Map View Not Available' />
      )}
    </PaneDeprecated>,

    <PaneDeprecated
      id='street'
      key='street'
      className={cx('pane')}
      label={
        <span
          className={cx('tab-label')}
          data-elm-id='property_gallery_panel_street'
        >
          <Icon
            name='street-view'
            iconStyle='light'
            style={{ color: 'inherit' }}
            size='large'
            className={cx('tab-icon')}
          />
          <span>Street view</span>
        </span>
      }
    >
      {hasValidCoords ? (
        <Map
          {...coords}
          streetview
          className={cx('street-view')}
          elmId='property_gallery_panel_street_view'
          apiKey={config.GOOGLE_MAP_CLIENT_ID}
          apiChannel={config.GOOGLE_MAP_CHANNEL}
        />
      ) : (
        <NotAvailable text='Street View Not Available' />
      )}
    </PaneDeprecated>,
  ])

  return (
    <MediaPanel
      elmId='property_gallery_panel'
      cls={{ close: cx('close') }}
      className={cx('root')}
      view={view}
      onClose={onClose}
    >
      {({ view, setView }) => (
        <div className={cx('content')}>
          <div
            className={cx('address')}
            data-elm-id='property_gallery_panel_address'
          >
            <h4 data-elm-id='property_gallery_panel_address1'>
              {addressTuple[0]}
            </h4>
            <p data-elm-id='property_gallery_panel_address2'>
              {addressTuple[1]}
            </p>
          </div>
          <MediaView className={cx(`view-${view}`)}>
            <TabsDeprecated
              role='secondary'
              selected={view}
              onSelect={id => {
                setView(id)
                onViewChange(id)
              }}
              cls={{
                tab: cx('tab'),
                tabSelected: cx('tab-selected'),
              }}
            >
              {panes}
            </TabsDeprecated>
            {children}
          </MediaView>
        </div>
      )}
    </MediaPanel>
  )
}
/* eslint-enable react/jsx-curly-newline */
Overlay.propTypes = {
  addressTuple: PropTypes.arrayOf(PropTypes.string).isRequired,
  coords: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  view: PropTypes.string.isRequired,
  onViewChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  children: PropTypes.element,
}

export default Overlay
